import React from "react";
import Row from "./Row";
import { CalcRow, CalcSection } from './helpers';
import { parseSmallAmount } from './../common-helpers';

interface Props {
	category: string,
	section: CalcSection,
	sectionIndex: number,
	sectionTotal: number,
	selectedBudgetPeriod: number,
	addRow: (category: string, sectionIndex: number) => void,
	updateState: (category: string, sectionIndex: number, rowIndex: number, row: CalcRow) => void,
	deleteRow: (category: string, sectionIndex: number, rowIndex: number) => void,
}

const Section: React.FC<Props> = ({category, section, sectionIndex, sectionTotal, selectedBudgetPeriod, addRow, updateState, deleteRow}) => {

	const addRowHandler = (event: React.SyntheticEvent<HTMLButtonElement>) => {
		event.preventDefault();
		addRow(category, sectionIndex);
	};

	return (
		<section className="budget-section">
			<header>
				<span className="budget-section-title">{section.sectionLabel}</span>
				<button
					className="budget-section-add-row"
					type="button"
					name={section.sectionLabel}
					data-testid={`add-row-${category}-${sectionIndex}`}
					onClick={addRowHandler}>+ Add Row</button>
			</header>
			<div className="budget-tablehead">
				<span className="budget-tablehead-left">Expense</span>
				<span className="budget-tablehead-center">Amount / Frequency</span>
				<span className="budget-tablehead-right">Amount for budget period</span>
			</div>
			{section.data && section.data.map((row: CalcRow, index: number) => (
				<Row
					category={category}
					updateStateHandler={updateState}
					sectionIndex={sectionIndex}
					selectedBudgetPeriod={selectedBudgetPeriod}
					row={row}
					rowIndex={index}
					deleteRow={deleteRow}
					key={`row-${sectionIndex}-${index}`}
				/>
      ))}
			<div className="budget-period-subtotal"><span>Budget Period Total:</span><span>{parseSmallAmount(sectionTotal.toString())}</span></div>
		</section>
	);
};

export default Section;
